import React from 'react';
import clsx from 'clsx';
import AutoComplete from './AutoComplete';
import { findCombinationIndex } from '../../../../../../validations/validations';

const AnnotationNameRow = ({
    annotationName,
    setAnnotationName,
    newSelected,
    annotationType,
    entity,
    clickedEdit,
    selectedProject,
    compareLock,
    setAttributeParam,
    setValueParam,
    setLogicalOperatorParam,
    setComparisonOperatorParam,
    setAnnotationType,
    setEntity,
    setEntityName,
    setAnnotationTable,
    setAttributeType,
    setAttributeTypeService,
    setCustomAttributeType,
    setNewSelected,
    setFunctionName,
    setServiceSelectedAttr
  }) => (
    <div>
      <span>Annotation name: &nbsp; </span>
      <div style={{ display: 'inline-flex', paddingTop: '0.5vw', marginLeft: '2vw' }}>
        
        <AutoComplete
          annotationName={annotationName}
          setAnnotationName={setAnnotationName}
          newSelected={newSelected}
          annotationType={annotationType}
          entity={entity}
          clickedEdit={clickedEdit}
          selectedProject={selectedProject}
          setAttributeParam={setAttributeParam}
          setValueParam={setValueParam}
          setLogicalOperatorParam={setLogicalOperatorParam}
          setComparisonOperatorParam={setComparisonOperatorParam}
          setAnnotationType={setAnnotationType}
          setEntity={setEntity}
          setEntityName={setEntityName}
          setAnnotationTable={setAnnotationTable}
          setAttributeType={setAttributeType}
          setAttributeTypeService={setAttributeTypeService}
          setCustomAttributeType={setCustomAttributeType}
          setNewSelected={setNewSelected}
          setFunctionName={setFunctionName}
          setServiceSelectedAttr={setServiceSelectedAttr}
        />
      </div>
  
      <span
          className={clsx('MuiFormHelperText-root', 'Mui-error')}
          style={
              findCombinationIndex(annotationName,selectedProject) !== -1 && compareLock === true
              ? { display: 'inherit' }
              : { display: 'none' }
          }
        >
          Changes will be applied to all components with same annotation name
        </span>
  
    </div>
);
  
export default AnnotationNameRow;